import { useToasts } from "react-toast-notifications";

import { GenericTooltip } from "@components/tooltip-container";

export const LinkClipboardButton = ({
  value,
  name,
}: {
  value: string;
  name?: string;
}) => {
  const { addToast } = useToasts();
  return (
    <GenericTooltip content={`Copy ${name}`} noInfoCircle placement="top">
      <button
        onClick={() => {
          window.navigator.clipboard.writeText(value);
          addToast(`${name ? `'${name}' copied` : "Copied"} to clipboard!`, {
            appearance: "success",
          });
        }}
      >
        <i className="fa-sharp fa-regular fa-link text-cosmic" />
      </button>
    </GenericTooltip>
  );
};
